"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "body1StrongClassNames", {
    enumerable: true,
    get: function() {
        return _useBody1StrongStylesstyles.body1StrongClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Body1Strong"), exports);
const _useBody1StrongStylesstyles = require("./useBody1StrongStyles.styles");
